import { actionTypes } from "../contants/actionTypes";

const initialState = {
    isLoading: false,
    error: null,
    // Company
    companyInfo: null,
    userCompanies: [],
    selectedCompanyId: null,
    // Company View
    companyViewInfo: null,
    companyViewSelectedId: null,
    companyViewActive: false,
    // Company configuration
    configuration: {},
    //Pending action and changes
    changesPending: false,
    actionPending: {},
    actionRequired: false
};

export const sessionStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.sessionStateLoadStart:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actionTypes.sessionStateLoadFinish:
            return {
                ...state,
                isLoading: false,
            };
        case actionTypes.companyConfigLoadCompanies:
            return {
                ...state,
                userCompanies: action.payload,
            };
        case actionTypes.companyConfigSetSelected:
            return {
                ...state,
                selectedCompanyId: action.payload.id_company,
                companyInfo: action.payload,
            };
        case actionTypes.companyConfigError:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        // Company View
        case actionTypes.companyConfigStartViewAs:
            return {
                ...state,
                companyViewSelectedId: action.payload.id_company,
                companyViewInfo: action.payload,
                companyViewActive: true,
            };
        case actionTypes.companyConfigEndViewAs:
            return {
                ...state,
                companyViewActive: false,
                companyViewInfo: null,
                companyViewSelectedId: null,
            };
        // Company configuration
        case actionTypes.companyConfigSetConfigurationData:
            return {
                ...state,
                configuration: action.payload,
            };
        //Pending action or cahnge
        case actionTypes.sessionStateChangesPending:
            return {
                ...state,
                changesPending: action.payload,
            }
        case actionTypes.sessionStateActionPending:
            return {
                ...state,
                actionPending: action.payload,
            }
        case actionTypes.sessionStateActionRequired:
            return {
                ...state,
                actionRequired: action.payload,
            }
        default:
            return state;
    }
};
